import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import EffectCategory from '../../../domain/entities/EffectCategory';

export default function reducer(
  state: {[key: number]: EffectCategory} = {},
  action: AnyAction,
): {[key: number]: EffectCategory} {
  switch (action.type) {
    case Types.IndexEffectCategoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: EffectCategory}, record: EffectCategory) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowEffectCategorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
